import React, { Component } from 'react';
import {Box, Text, Spacer, Grid, GridItem, Image, Badge, HStack, Modal, ModalBody, ModalOverlay, ModalCloseButton, ModalContent } from "@chakra-ui/react";


import "../../../assets/css/generic-report.css";

// import { Jsondiver } from '@textea/json-diver'
import _, { toInteger } from "lodash";

import ConfigService from '../../../services/ConfigService';
import CoreService from "../../../services/CoreService";
import LocalStorageService from "../../../services/LocalStorageService";

import CardUtils from '../../Observation/Components/Models/CardUtils';

import GCLogo from "../../../assets/images/logos/glasschain-img-only.png";

import ReportDataFactory from "./Managers/ReportDataFactory";
import JavascriptHelpers from '../../../components/lib/Javascript/JavascriptHelpers';


function getSchemaPdfType(schemaId) {
    var lcSchemaId = schemaId.toLowerCase();
    if (lcSchemaId.includes('truckinspection')) return "passfail";
    if (lcSchemaId.includes('storevisit')) return "passfail";
    if (lcSchemaId.includes('covid-wellness-check')) return "passfail";
    if (lcSchemaId.includes("-om")) return "usda";
    if (lcSchemaId.includes("-usda")) return "usda";
    if (lcSchemaId.includes("-ma")) return "ma";
    if (lcSchemaId.includes("testplot")) return "passfail";
    return "default";
}

function toBool(val) {
    var result = val === 'true' ? true :
        val === 'false' ? false :
            val;
    return result;
}

function idToTitle(id, schema)
{
    const lowerId = CardUtils.titleToId(id);
    for(var c=0; c<schema.categories.length; c++)
    {
        let category = schema.categories[c];
        for (var g=0; g<category.groups.length; g++)
        {
            let group = category.groups[g];
            for(var d=0; d< group.cards.length; d++)
            {
                let card = group.cards[d];
                if ((card.id === lowerId) || (CardUtils.titleToId(card.title) === lowerId))
                {
                    return ((card.label) ? card.label : card.title ? card.title : id);
                }
            }
        }
    }
    return "Unknown";        
}

const fieldIdsToSuppress = [
    "Inspector", "HarvestDate"
] 


export default class ObservationPdfVrsn2 extends Component {
    constructor(props) {
        super(props);

        this.configService = new ConfigService();
        this.state = {
            reportData: null,
            isLoading: false,
            errorMessage: "",
            customerLogoImgSrc: "",
            isOpen: false,
            modalSrc: ''
        };


        this.appConfig = new ConfigService();

        // this.inspectDate = new Date(this.state.reportData.observation.data.Raw.inspectiondate);
        this.totalDefects = "";

        // this.schemaPdfType = getSchemaPdfType(this.state.reportData.observation.data.schema.id);
        this.drawInspection = this.drawInspection.bind(this);
        this.drawEnvironment = this.drawEnvironment.bind(this);
        //this.userImages = this.userImages.bind(this);
        this.makeUserImages = this.makeUserImages.bind(this);
        this.makeDocuments = this.makeDocuments.bind(this);
        this.onClose = this.onClose.bind(this);
        this.setModalSrc = this.setModalSrc.bind(this);

        this.localStorageService = new LocalStorageService();
        this.coreService = new CoreService();
        this.refreshData = this.refreshData.bind(this);

    }


    async componentDidMount() {
        let customerLogoImgSrc = this.configService.getCustomerLogoImagePath(this.props.userSession.gcid);
        this.setState({
          customerLogoImgSrc: customerLogoImgSrc
        });
        if (this.props.observationId) {
            await this.refreshData();
        }
    }

    async componentDidUpdate(prevProps, prevState) {
        if ((prevProps.observationId !== this.props.observationId) || (prevProps.reportName !== this.props.reportName)) {
            if (this.props.observationId) {
                await this.refreshData();
            }
        }
    }

    async refreshData() {
        try {
            this.setState({ isLoading: true, errorMessage: "" });
            var dataResponse = await ReportDataFactory.ReportData(this.props.reportName, this.props.observation, this.props.userSession.uid, this.props.userSession.gcid, this.props.userSession.token, this.props.shared);
            // TBD - error handling
            var reportData = dataResponse.data;
            this.setState({ reportData: reportData })
        }
        finally {
            this.setState({ isLoading: false });
        }
    }

    gcidLogo() {
        return (
            <Image className='companylogo' src={this.state.customerLogoImgSrc}
            />
        )
    }

    drawPassFailScore() {
        var result = [];
        result.push(<Text style={{marginRight: "10px"}}>{"Scoring Schema: " + this.state.reportData.observation.score.Score.Scorer.id}</Text>);
        result.push(<Text style={{marginRight: "10px"}}>{"Scoring Schema Version: " + this.state.reportData.observation.score.Score.Scorer.version}</Text>);
        result.push(<Text style={{marginRight: "10px"}}>{"Scoring Schema Date: " + new Date(this.state.reportData.observation.score.Score.Scorer.lastUpdated).toLocaleDateString()}</Text>);
        result.push(<Text style={{marginRight: "10px"}}>{"Pass: " + this.state.reportData.observation.score.Score.Grade.Weighted}</Text>);
        return result;
    }

    drawMultAccelScore() {
        return (<Text>Mult/Accel Scoring</Text>)
    }

    isMultAccelGradeRule(gradeRule) {
        var gVal = gradeRule.weightedScore;
        return ((gVal != null) && (gVal !== 'undefined'));
        //return (gradeRule.weightedScore); // has weightedScore vs pct used in USDA.
    }

    drawCategorySeverityScore() {
        if (this.schemaPdfType === "passfail") return;
        var result = [];
        var byGrade = this.state.reportData.observation.score.Score.Gradient;
        var allRules = ["grade"];
        byGrade.forEach(grade => {
            var byRules = (grade.rules) ? grade.rules : [];
            byRules.forEach(rule => {
                if (!allRules.includes(rule.title)) {
                    allRules.push(rule.title);
                }
            })
        });

        // create header
        var headerRowArray = allRules.map(rule => {
            return <Text className='tableHeaders'>{rule}</Text>
        })
        //result.push(<div className='headerRow}>{headerRowArray}</div>);

        // for each grade
        byGrade.forEach(grade => {
            let gradeRowArray = new Array(allRules.length - 1);

            var gradeCell = (grade.passed) ?
                <Text className='cellPassed'>{grade.grade}</Text> :
                <Text className='cellFailed'>{grade.grade}</Text>
            gradeRowArray[0] = gradeCell;
            for (var i = 1; i < allRules.length; i++) {
                let cell = <Text className='cellNotGraded'> -- </Text>
                var gradeRules = (grade.rules) ? grade.rules : [];
                console.log("grade rules:");
                console.log(gradeRules);
                for (var j = 0; j < gradeRules.length; j++) {
                    var cellDescript = "";
                    if (gradeRules[j].title === allRules[i]) {
                        if (this.isMultAccelGradeRule(gradeRules[j])) { // TBD: multAccell uses a different property and boolean symbol. Should be defined in the schema scoring info itself! 
                            cellDescript = '>' + gradeRules[j].description.split('>')[1] + ' [' + gradeRules[j].weightedScore.toString().substring(0, 7) + '%]';
                        }
                        else {
                            cellDescript = '<=' + gradeRules[j].description.split('<=')[1] + ' [' + gradeRules[j].pct.toString().substring(0, 7) + '%]'; // must be a USDA-type
                        }
                        cell = (gradeRules[j].passed) ?
                            <Text className='cellPassed'>{cellDescript}</Text> :
                            <Text className='cellFailed'>{cellDescript}</Text>;
                    }
                }
                gradeRowArray[i] = cell;
            }
            result.push(<div className='cellRow'>{gradeRowArray}</div>);

        });

        return result;
    }

    makeGradeHeader(gradeName, gradeResult, didPass) {
        var result =
            <div className='gradeTitleRow'>
                <div className='gradeTitleCol'>
                    <Text className='gradeTitleCellRule'>{gradeName}</Text>
                </div>
                <div className='gradeTitleResultCol'>
                    <Text className={(didPass) ? "gradeTitleCellPassResult" : "gradeTitleCellFailResult"}>{gradeResult}</Text>
                </div>
            </div>
        return result;
    }

    makeGradeRuleHeader() {
        var result =
            <div className='tableRow'>
                {/* <div className='tableColHeader'>
                    <Text className='tableCellHeader'>Rule</Text>
                </div> */}
                <div className='tableColHeader'>
                    <Text className='tableCellHeader'>Tolerances</Text>
                </div>
                {/* <div className='tableColHeader'>
                    <Text className='tableCellHeader'>Total</Text>
                </div> */}
                <div className='tableColHeader'>
                    <Text className='tableCellHeader'>Score</Text>
                </div>
            </div>
        return result;
    }

    makeGradeRule(ruleName, ruleDescript, ruleTotal, rulePct, didRulePass) {
        var ruleTotalReduced = ruleTotal.toFixed(0);//toString().substring(0, 7);
        var rulePctReduced = JavascriptHelpers.roundHalfDown(rulePct).toFixed(0); //(toInteger(rulePct)).toFixed(0); //toString().substring(0, 7);
        var result =
            <div className='tableRow'>
                {/* <div className='tableCol'>
                    <Text className='tableCell'>{ruleName}</Text>
                </div> */}
                <div className='tableCol'>
                    <Text className='tableCell'>{ruleDescript}</Text>
                </div>
                {/* <div className='tableCol'>
                    <Text className='tableCellNumber'>{ruleTotalReduced}</Text>
                </div> */}
                <div className='tableCol'>
                    <Text className={(didRulePass) ? "pctTableCellPassResult" : "pctTableCellFailResult"}>{rulePctReduced}</Text>
                </div>
            </div>

        return result;
    }

    makeGradeTable(gradeArray) {
        var result =
            <div className='table'>
                {gradeArray}
            </div>
        return result;
    }

    makeGradeTableSpacer() {
        var result =
            <div><Text>   </Text></div>

        return result;
    }

    isCutoffGrade(grade, cutoffGrade) {
        var testCutoffGrade = (cutoffGrade) ? cutoffGrade.grade : "REJECT";
        return (grade.toLowerCase() === testCutoffGrade.toLowerCase());
    }

    drawCategorySeverityScore2() {
        if (this.schemaPdfType === "passfail") return;
        var result = [];
        var byGrade = this.state.reportData.observation.score.Score.Gradient;

        // for each grade, create a separate section
        byGrade.forEach(grade => {
            //if (grade.grade === "REJECT") 
            // we do NOT show rules for the cutoff grade because the rule IS that the
            // observation HIT the cutoff grade. Usually reject, but NOT ALWAYS.
            if (this.isCutoffGrade(grade.grade, this.state.reportData.schema.scoring.cutoffGrade)) { return }

            var gradeArray = [];
            // create "grade" header
            var gradePassed = (this.isMultAccelGradeRule(grade.rules[0])) ? grade.passed : toBool(grade.didGradePass);

            var gradeHeader = this.makeGradeHeader(grade.grade, (gradePassed) ? "PASS" : "FAIL", gradePassed);
            gradeArray.push(gradeHeader);
            var gradeRuleHeader = this.makeGradeRuleHeader();
            gradeArray.push(gradeRuleHeader);
            var gradeRules = (grade.rules) ? grade.rules : [];
            gradeRules.forEach(rule => {
                var rulePct = (this.isMultAccelGradeRule(rule)) ? rule.weightedScore : rule.pct;
                var rulePassed = (this.isMultAccelGradeRule(rule)) ? rule.passed : toBool(rule.didRulePass);
                var gradeRule = this.makeGradeRule(rule.title, rule.description, rule.totalDefects, rulePct, rulePassed);
                gradeArray.push(gradeRule);
            })
            // TBD - grade rule table
            var gradeTable = this.makeGradeTable(gradeArray);
            result.push(gradeTable);
            result.push(this.makeGradeTableSpacer());
        });

        return result;
    }

    normalizeCategorySeverityDefects() {
        var result = [];
        var byCategory = this.state.reportData.observation.score.Score.GlobalDefects.ByCategory;
        var byDefect = this.state.reportData.observation.score.Score.GlobalDefects.ByDefect;
        console.log(this.state.reportData.observation.score.Score);
        for (var i = 0; i < byCategory.length; i++) {
            var cat = { "defectGroup": byCategory[i].category + '-' + byCategory[i].degree, "value": byCategory[i].value, "defects": [] };
            for (var j = 0; j < byDefect.length; j++) {
                if (byDefect[j].category === byCategory[i].category && byDefect[j].degree === byCategory[i].degree) {
                    cat.defects.push({ "defect": byDefect[j].cardTitle, "count": byDefect[j].count })
                }
            }
            result.push(cat);
        }
        return result;
    }

    normalizePassFailConditions() {
        var result = [];
        var cat = { "defectGroup": "Failed Conditions", "value": null, "defects": [] };
        var failedConditions = this.state.reportData.observation.score.Score.FailedConditions;
        // if for some reason there ARE NO failedConditions, then just re-initialize empty! 
        if (!failedConditions) {
            failedConditions = [];
        }
        failedConditions.forEach(cond => {

            cat.defects.push({ "defect": cond, "count": null })
        });
        result.push(cat);
        return result;
    }

    preInspectRejectDefects() {
        console.log(this.obsData);
        var result = [];
        result.push(<Text>PreInspect Rejection</Text>);
        this.state.reportData.observation.data.PreInspectStatus.Tags.forEach(tag => {
            result.push(<Text>--{tag}</Text>)
        });

        return result;
    }

    makeDefectHeader(headerName) {
        var result =
            <div className='defectCategoryRow'>
                <div className='defectCategoryCol'>
                    <Text className='gradeTitleCellRule'>{headerName}</Text>
                </div>
            </div>
        return result;
    }

    makeDefect(defectName) {
        var result =
            <div className='defectCol'>
                <Text className='defectNoValueCell'>{defectName}</Text>
            </div>

        return result;
    }

    makeDefectRow(defects) {
        var result =
            <div className='defectValueRow'>{defects}</div>

        return result
    }

    defectCount(defectName, variants, rawObsData) {
        var result = 0;
        if (variants) {
            variants.forEach((variant) => {
                var lookupFormat = defectName + variant.toLowerCase();
                var val = rawObsData[lookupFormat.toLowerCase()];
                var valCount = (val) ? parseInt(val) : 0;
                result += valCount;
            });
        }
        else {
            var lookupFormat = defectName;
            var val = rawObsData[lookupFormat.toLowerCase()];
            var result = (val) ? parseInt(val) : 0;
        }
        return result;
    }

    hasDefectValue(defectName, variants, rawObsData) {
        var result = false;
        if (variants) {
            variants.forEach((variant) => {
                if (result) return;
                var lookupFormat = defectName + variant.toLowerCase();
                var val = rawObsData[lookupFormat.toLowerCase()];
                if (val) {
                    result = true;
                }
            });
        }
        else {
            var lookupFormat = defectName;
            var val = rawObsData[lookupFormat.toLowerCase()];
            result = val;
        }
        return result;
    }

    makeValDefect(defectName, variants, rawObsData) {
        var valueTextElements = [];
        if (variants) {
            variants.forEach((variant) => {
                var lookupFormat = defectName + variant.toLowerCase();
                var val = rawObsData[lookupFormat.toLowerCase()];
                if (val) {
                    valueTextElements.push(<Text className='defectDegreeCountText'>{variant}: {val}</Text>);
                }
            });
        }
        else {
            var lookupFormat = defectName;
            var val = rawObsData[lookupFormat.toLowerCase()];
            valueTextElements.push(<Text className='defectDegreeCountText'>{val}</Text>);
        }

        var result = <div className='defectValueCol'>
            <Text className='defectValueText'>{idToTitle(defectName, this.state.reportData.schema)}</Text>
            {valueTextElements}
        </div>

        return result;
    }

    makeDefectTotals(totalInspected, totalDefects) {
        var result =
            <div className='table'>
                {this.makeDefectHeader("Totals")}
                <div className='defectValueRow'>
                    <div className='defectCol'>
                        <Text className='defectTotalCell'>Total Inspected</Text>
                    </div>
                    <div className='defectCol'>
                        <Text className='defectTotalCell'>Total Defects</Text>
                    </div>
                </div>

                <div className='defectValueRow'>
                    <div className='defectCol'>
                        <Text className='defectTotalText'>{totalInspected}</Text>
                    </div>
                    <div className='defectCol'>
                        <Text className='defectTotalText'>{totalDefects}</Text>
                    </div>
                </div>
            </div>

        return result;
    }

    drawDefects2() {
        if (this.state.reportData.observation.score.Score.IsPreInspectRejected === true) {
            return this.preInspectRejectDefects();
        }
        var totalInspected = this.state.reportData.observation.score.Score.TotalInspected;
        var totalDefects = 0; // we will calculate this as we go along

        var result = [];
        var normalizedDefects = (this.schemaPdfType === "passfail") ? this.normalizePassFailConditions() : this.normalizeCategorySeverityDefects();
        console.log(normalizedDefects);
        var schemaDefects = this.state.reportData.schema.categories.find(cat => cat.id === "defects");
        var schemaDefectGroups = schemaDefects.groups;

        schemaDefectGroups.forEach((grp) => {
            // "count"/"weight" is not actually a defect group for this report
            if ((grp.groupTitle.toLowerCase() === "count") || (grp.groupTitle.toLowerCase() === "weight")) return;
            var groupArray = [];
            var groupHeader = this.makeDefectHeader((grp.label) ? grp.label.toUpperCase() : grp.groupTitle.toUpperCase());
            groupArray.push(groupHeader);
            var rowArray = [];
            var groupDefects = grp.cards;
            var rowDefects = [];
            for (var i = 0; i < groupDefects.length; i++) {
                //Can we change the assignment of the ID to something more readable
                var defectId = (groupDefects[i].id) ? groupDefects[i].id : CardUtils.titleToId(groupDefects[i].title);
                var hasDefectVal = this.hasDefectValue(defectId, groupDefects[i].variants, this.state.reportData.observation.data.Raw);
                var defectCount = (hasDefectVal) ? this.defectCount(defectId, groupDefects[i].variants, this.state.reportData.observation.data.Raw) : 0;
                totalDefects += defectCount;
                var defect = (hasDefectVal) ?
                    this.makeValDefect(defectId, groupDefects[i].variants, this.state.reportData.observation.data.Raw) :
                    this.makeDefect((groupDefects[i].label) ? groupDefects[i].label : groupDefects[i].title);
                rowDefects.push(defect);
                var x = (i === 5);
                var yMod = ((i - 1) % 5);
                var y = ((((i - 1) % 5) === 0) && (i > 6));
                var z = (i === groupDefects.length - 1);
                if (x || y || z) {
                    var atEnd = (i === groupDefects.length - 1);
                    var sliceStart = (atEnd) ?
                        (i - ((i + 1) % 6)) + 1 :
                        i - 5;
                    var sliceEnd = (atEnd) ?
                        groupDefects.length :
                        i + 1;
                    if(sliceStart == groupDefects.length){
                        sliceStart= 0
                    }
                    var slicedRowDefects = rowDefects.slice(sliceStart, sliceEnd);
                    var defectRow = this.makeDefectRow(slicedRowDefects);
                    rowArray.push(defectRow);
                    //rowDefects.splice(0, rowDefects.length);  // empty the "working" array
                }
            }
            groupArray.push(rowArray);
            var defectTable = this.makeGradeTable(groupArray);
            result.push(defectTable);
            result.push(this.makeGradeTableSpacer());
        });
        // put in totals table
        result.push(this.makeDefectTotals(totalInspected, totalDefects));
        return result;
    }

    drawInspection() {
        //keyed in values that look too much like a date are being appended with date info lol ++++++++++++++++++++++++++++++++++++++++++++++++
        var results = [];
        if (this.state.reportData.observation.data.UnderInspection) {
            var inspectData = this.state.reportData.observation.data.UnderInspection;
            for (const [key, value] of Object.entries(inspectData)) {
                if((value) && (!fieldIdsToSuppress.includes(key))) 
                {
                    if (key === "InspectionDate" || key === "HarvestDate") {
                        if (value) {
                            var tempdate = value
                            results.push(<Text className='sectiontext'>{idToTitle(key, this.state.reportData.schema)}: {tempdate}</Text>)
                        }
                    } else if (Array.isArray(value))
                    {
                        results.push(<Text className='sectiontext'>{idToTitle(key, this.state.reportData.schema)}: {value.join(", ")}</Text>)
                    }
                    else {
                        results.push(<Text className='sectiontext'>{idToTitle(key, this.state.reportData.schema)}: {value}</Text>)
                    }
                }
            }
            return results
        } else {
            return <Text>-------</Text>
        }

    }

    drawEnvironment() {
        var results = [];
        if (this.state.reportData.observation.data.Environment) {
            var envData = this.state.reportData.observation.data.Environment;
            for (const [key, value] of Object.entries(envData)) {
                if (value && key !== "Comments") {

                    results.push(<Text className='sectiontext'>{key}: {value}</Text>)
                }
            }
            if (results.length > 0) {
                return results;
            }
            else {
                return <Text>No Environmental Data Recorded</Text>
            }
        }
    }

    makeUserImages(report) {
        var imageData = this.state.reportData.observation.data.Raw.userimages;
        if (!imageData) return <Text>No User Images</Text>
    
        var imageGridItems = imageData.map(data => {
          var fullSrc = this.configService.getGcidUserImageBasePath(this.props.userSession.gcid) + data.id + "." + data.ext;
          var thumbSrc = this.configService.getGcidUserImageBasePath(this.props.userSession.gcid) + data.thumbnailId + "." + data.ext;
          //var imgFull = (data.thumbnailFile !== '') ? data.thumbnailFile : data.imageFile;
          var tags = data.tags.map((tag) => {
            return <Badge>{tag.label}</Badge>
          })
    
          return <GridItem>
            {/* <Badge variant={"outline"}>{data.pallets}</Badge> */}
    
    
            <img src={thumbSrc} onClick={() => this.setModalSrc(fullSrc)} />
    
            {(data.descript) &&
              <Text>{data.descript}</Text>
            }
            {tags}
    
          </GridItem>
        })
    
        var imageGrid =
          <Grid
            templateColumns="repeat(6, 1fr)"
          >
            {/*
            <GridItem colSpan={6} h={4} bg="white" />
            <GridItem colSpan={6}><Text fontSize={20} fontWeight={"bold"} bg={"lightblue"}>Inspection Images</Text></GridItem>
            <GridItem colSpan={6} h={2} bg="white" />
            */}
            {imageGridItems}
          </Grid>
        return imageGrid
      }
    
      makeDocuments(report) {
        var docData = this.state.reportData.observation.data.Raw.userDocuments;
        if (!docData) return <Text>No User Documents</Text>
        var path = this.configService.getGcidUserDocBasePath(this.props.userSession.gcid)
    
        var docItems = docData.map(data => {
          var thumbSrc = this.configService.getGcidUserImageBasePath(this.props.userSession.gcid) + data.thumbnailFile;
          return <GridItem>
            <Badge variant={"outline"}>{data.pallets}</Badge>
            <a href={path + data.docFile} target="_blank"><Image src={thumbSrc} /></a>
            {/* <Text>{data.description}</Text> */}
            <Text><a href={path + data.docFile} target="_blank">{data.description}</a></Text>
          </GridItem>
        })
    
        var docGrid =
          <Grid
            templateColumns="repeat(4, 1fr)"
          >
            {/*
            <GridItem colSpan={4} h={4} bg="white" />
            <GridItem colSpan={4}><Text fontSize={20} fontWeight={"bold"} bg={"lightblue"}>Inspection Documents</Text></GridItem>
            <GridItem colSpan={4} h={2} bg="white" />
            */}
            {docItems}
          </Grid>
        return docGrid
      }


      onClose() {
        this.setState({
          isOpen: false
        })
      }
    
      setModalSrc(thisModalSrc) {
        this.setState({
          modalSrc: thisModalSrc,
          isOpen: true
        })
      }

    render() {
        var today = new Date().toDateString()


        //Items not entered in the app will look like blank fields in the text++++++++++++++++++++++
        return (

            
            <div>


                <Modal isOpen={this.state.isOpen} onClose={this.onClose} size={'full'}>
                    <ModalOverlay />
                    <ModalContent>
                        <ModalCloseButton />
                        <ModalBody style={{margin: "auto"}}>
                            <img src={this.state.modalSrc} />
                        </ModalBody>
                        </ModalContent>
                </Modal>


                {(this.state.reportData) ?
                    <div className='page' wrap={true}>

                        <div className='header'>
                            <div style={{width:'33%'}}> {this.gcidLogo()}</div>
                            <div style={{width:'33%', textAlign: 'center'}}> <Text style={{ fontSize: '24px' }}>QA Inspection Report</Text> </div>
                            <div style={{width:'33%', textAlign: 'right'}}> <Text className='datetext'>{today}</Text> </div>
                        </div>
{/* 
                        <div className='summary'>
                            <div className='sectionheading'><Text className='sectionheadingtext'>Summary: {this.state.reportData.observation.score.Score.Grade.Raw}</Text></div>

                            <div className='sectionbody'>
                                <Text className='sectiontext'>Date: {this.state.reportData.observation.data.UnderInspection.InspectionDate}</Text>
                                <Text className='sectiontext'>Commodity: {this.state.reportData.observation.data.schema.name}</Text>
                                <Text className='sectiontext'>Location: {this.state.reportData.observation.data.UnderInspection.Location}</Text>
                                <Text className='sectiontext'>Item Name: {this.state.reportData.observation.data.Raw.itemdescript}</Text>
                                <Text className='sectiontext'>Inspector: {this.state.reportData.observation.data.UnderInspection.Inspector}</Text>
                            </div>
                        </div> */}

                        <div className='inspect'>
                            <div className='sectionheading'><Text className='sectionheadingtext'>Summary: {this.state.reportData.observation.score.Score.Grade.Raw}</Text></div>
                            <div className='sectionbody'>
                                {this.drawInspection()}
                            </div>

                        </div>

                        <div className='defects'>
                            <div className='sectionheading'>
                                <Text className='sectionheadingtext'>Defects</Text>
                            </div>
                            <div className='sectionbody'>
                                {this.drawDefects2()}
                            </div>
                        </div>

                        <div className='score'>
                            <div className='sectionheading'><Text className='sectionheadingtext'>Scoring</Text></div>
                            <div className='sectionbody'>
                                {this.drawCategorySeverityScore2()}
                                {this.drawPassFailScore()}
                            </div>
                        </div>
                        <div className='comments' wrap={false}>
                            <div className='sectionheading'><Text className='sectionheadingtext'>Comments</Text></div>
                            <div className='sectionbody'>
                                <Text className='commentstext'>{(this.state.reportData.observation.data.Raw.comments) ? this.state.reportData.observation.data.Raw.comments : "No Inspector Comments"}</Text>
                            </div>
                        </div>
                        <div className='environment' wrap={false}>
                            <div className='sectionheading'><Text className='sectionheadingtext'>Environment</Text></div>
                            <div className='sectionbody'>
                                {this.drawEnvironment()}
                            </div>
                        </div>

                        <div className='images' break>
                            <div className='sectionheading'><Text className='sectionheadingtext'>User Images</Text></div>
                            <div className='sectionbody'>
                                {this.makeUserImages()}
                            </div>
                        </div>

                        <div className='images' break>
                            <div className='sectionheading'><Text className='sectionheadingtext'>User Documents</Text></div>
                            <div className='sectionbody'>
                                {this.makeDocuments()}
                            </div>
                        </div>

                        <div className='poweredby'>
                            <Text className='poweredbytext'>powered by {"\n"}  glassbit</Text>
                            <Image className='poweredbyimage' src={GCLogo} />
                        </div>
                        <div className='footer'>

                        </div>
                    </div>
                    :
                    ""
                }
            </div >

        )
    }
}